/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AbsenceStatisticsRequest,
  AbsenceStatisticsResponse,
  AbsencesResponse,
  BulkApprovalsUpdateRequestDto,
  PageUserWithAbsencesDto,
  UserWithAbsencesRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiAbsencesController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-absences-controller
   * @name BulkAbsencesUpdate
   * @request POST:/api/v1/users/{userId}/absences/bulk-update
   */
  bulkAbsencesUpdate = (
    userId: string,
    data: BulkApprovalsUpdateRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/users/${userId}/absences/bulk-update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static bulkAbsencesUpdatePath = '/v1/users/${userId}/absences/bulk-update'
  static bulkAbsencesUpdateMethod = 'POST'
  /**
   * No description
   *
   * @tags api-absences-controller
   * @name UsersAbsenceSummary
   * @request POST:/api/v1/users/absence-summary
   */
  usersAbsenceSummary = (data: UserWithAbsencesRequest, params: RequestParams = {}) =>
    this.http.request<PageUserWithAbsencesDto, any>({
      path: `/v1/users/absence-summary`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static usersAbsenceSummaryPath = '/v1/users/absence-summary'
  static usersAbsenceSummaryMethod = 'POST'
  /**
   * No description
   *
   * @tags api-absences-controller
   * @name AbsenceStatistics
   * @request POST:/api/v1/users/absence-stats
   */
  absenceStatistics = (data: AbsenceStatisticsRequest, params: RequestParams = {}) =>
    this.http.request<AbsenceStatisticsResponse, any>({
      path: `/v1/users/absence-stats`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static absenceStatisticsPath = '/v1/users/absence-stats'
  static absenceStatisticsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-absences-controller
   * @name GetAbsences
   * @request GET:/api/v1/users/{userId}/absences
   */
  getAbsences = (userId: string, params: RequestParams = {}) =>
    this.http.request<AbsencesResponse, any>({
      path: `/v1/users/${userId}/absences`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAbsencesPath = '/v1/users/${userId}/absences'
  static getAbsencesMethod = 'GET'
}
